import { AlternateUnitOfMeasure } from './alternate-unit-of-measure';

export interface UnitOfMeasure {
  id: string;
  description: string;
  shortDescription: string;
  key: string;
  labOnlyUOM: boolean;

  alternateUnitOfMeasure: AlternateUnitOfMeasure[];
}
